import axios from 'axios'
import { useRef, useState } from 'react'
import { toast } from 'react-hot-toast'
import InputMask from 'react-input-mask'
import { useParams } from 'react-router-dom'
import { toApiUrl } from 'lib/api'

export default function FaceMatch({
  event: _event,
  onSuccess,
}: {
  event: any
  onSuccess: () => void
}) {
  const ref = useRef<HTMLInputElement>(null)

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [mode, setMode] = useState<'scan' | 'register'>('scan')
  const [file, setFile] = useState<File | null>(null)

  const { code } = useParams()

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target

    if (files?.length) {
      setFile(files[0])
      setMode('register')
    }
  }

  const handleSubmit = async () => {
    if (!file) {
      return
    }

    setIsLoading(true)

    const storeFormData = new FormData()

    storeFormData.append('file_upload', file)
    const phoneNumberWithoutSpaces = phoneNumber.replace(/\s/g, '')
    const phoneNumberWithCountryCode = `+90${phoneNumberWithoutSpaces}`
    const encodedPhone = encodeURIComponent(phoneNumberWithCountryCode)

    try {
      await axios.post(
        toApiUrl(
          `/face/search?event_code=${code}&full_name=${firstName} ${lastName}&receiverphone=${encodedPhone}&similarity=60&zip_file=true`
        ),
        storeFormData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )

      setIsSuccess(true)
    } catch {
      toast.error('Bir sorun oluştu, lütfen daha sonra tekrar deneyiniz.')
    } finally {
      setIsLoading(false)
    }
  }

  if (mode === 'register') {
    return (
      <div className="p-[20px]">
        {isSuccess && (
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-80px)] bg-[#0B0B0B] rounded-[16px] flex flex-col items-center justify-center pt-[18px] pb-[24px] z-50">
            <div className="mb-[6px]">
              <svg
                width="94"
                height="94"
                viewBox="0 0 94 94"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M44.4286 1.542C46.0115 0.592791 47.9885 0.592792 49.5714 1.542L58.7949 7.07302C59.4438 7.46213 60.1725 7.69891 60.9262 7.76551L71.6392 8.71226C73.4777 8.87473 75.0772 10.0368 75.7999 11.7352L80.0108 21.6313C80.307 22.3275 80.7574 22.9474 81.328 23.4442L89.4385 30.5071C90.8304 31.7192 91.4414 33.5995 91.0277 35.3983L88.6176 45.8795C88.4481 46.6169 88.4481 47.3831 88.6176 48.1205L91.0277 58.6017C91.4414 60.4005 90.8304 62.2808 89.4385 63.4929L81.328 70.5558C80.7574 71.0526 80.307 71.6725 80.0108 72.3687L75.7999 82.2649C75.0772 83.9632 73.4777 85.1253 71.6392 85.2877L60.9262 86.2345C60.1725 86.3011 59.4438 86.5379 58.7949 86.927L49.5714 92.458C47.9885 93.4072 46.0115 93.4072 44.4286 92.458L35.2051 86.927C34.5562 86.5379 33.8275 86.3011 33.0738 86.2345L22.3608 85.2877C20.5223 85.1253 18.9228 83.9632 18.2001 82.2649L13.9892 72.3687C13.693 71.6725 13.2426 71.0526 12.672 70.5558L4.56148 63.4929C3.1696 62.2808 2.55865 60.4005 2.97226 58.6017L5.38235 48.1205C5.5519 47.3831 5.5519 46.6169 5.38235 45.8795L2.97226 35.3983C2.55865 33.5995 3.1696 31.7192 4.56149 30.5071L12.672 23.4442C13.2426 22.9474 13.693 22.3275 13.9892 21.6313L18.2001 11.7351C18.9228 10.0368 20.5223 8.87473 22.3608 8.71226L33.0738 7.76551C33.8275 7.69891 34.5562 7.46213 35.2051 7.07302L44.4286 1.542Z"
                  fill="#1E1E1E"
                />
                <circle cx="47" cy="47" r="23" fill="white" />
                <path
                  d="M42.38 52.94L35.285 45.845C34.68 45.24 33.91 44.9375 32.975 44.9375C32.04 44.9375 31.27 45.24 30.665 45.845C30.06 46.45 29.7575 47.22 29.7575 48.155C29.7575 49.09 30.06 49.86 30.665 50.465L40.07 59.87C40.73 60.53 41.5 60.86 42.38 60.86C43.26 60.86 44.03 60.53 44.69 59.87L63.335 41.225C63.94 40.62 64.2425 39.85 64.2425 38.915C64.2425 37.98 63.94 37.21 63.335 36.605C62.73 36 61.96 35.6975 61.025 35.6975C60.09 35.6975 59.32 36 58.715 36.605L42.38 52.94ZM47 80C42.435 80 38.145 79.1332 34.13 77.3996C30.115 75.666 26.6225 73.3153 23.6525 70.3475C20.6825 67.3775 18.3318 63.885 16.6004 59.87C14.869 55.855 14.0022 51.565 14 47C14 42.435 14.8668 38.145 16.6004 34.13C18.334 30.115 20.6847 26.6225 23.6525 23.6525C26.6225 20.6825 30.115 18.3318 34.13 16.6004C38.145 14.869 42.435 14.0022 47 14C51.565 14 55.855 14.8668 59.87 16.6004C63.885 18.334 67.3775 20.6847 70.3475 23.6525C73.3175 26.6225 75.6693 30.115 77.4029 34.13C79.1365 38.145 80.0022 42.435 80 47C80 51.565 79.1332 55.855 77.3996 59.87C75.666 63.885 73.3153 67.3775 70.3475 70.3475C67.3775 73.3175 63.885 75.6693 59.87 77.4029C55.855 79.1365 51.565 80.0022 47 80Z"
                  fill="#55B755"
                />
              </svg>
            </div>
            <div className="text-[18px] leading-[28px] text-white font-bold mb-[15px]">
              Hepsi tamam!
            </div>
            <div className="text-[14px] leading-[16px] text-[#989898] mb-[36px] text-center px-[24px]">
              İçerisinde olduğun kareleri WhatsApp ile sana ulaştıracağız.
            </div>
            <div>
              <div
                className="w-full bg-[#fff] text-[14px] leading-[22px] text-[#030303] font-bold rounded-[100px] px-[54px] py-[10px]"
                onClick={onSuccess}
              >
                Devam
              </div>
            </div>
          </div>
        )}
        <div className="text-[14px] mb-[10px]">
          Son bir adım kaldı! Size ulaşabilmemiz için bize WhatsApp numaranızı
          ve adınızı yazın:
        </div>
        <div className="flex flex-col gap-[10px] w-full mt-[30px]">
          <div className="flex gap-[10px]">
            <input
              placeholder="Ad"
              className="h-[56px] rounded-full bg-transparent border border-[#414141] text-[#fff] px-[20px] text-[15px] leading-[20px] placeholder:text-[rgba(255,255,255,0.3)] outline-none bg-[#090909] w-full"
              onChange={(e) => setFirstName(e.target.value)}
            />
            <input
              placeholder="Soyad"
              className="h-[56px] rounded-full bg-transparent border border-[#414141] text-[#fff] px-[20px] text-[15px] leading-[20px] placeholder:text-[rgba(255,255,255,0.3)] outline-none bg-[#090909] w-full"
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          {/* @ts-ignore */}
          <InputMask
            mask="999 999 9999"
            className="h-[56px] rounded-full bg-transparent border border-[#414141] text-[#fff] px-[20px] text-[15px] leading-[20px] placeholder:text-[rgba(255,255,255,0.3)] outline-none bg-[#090909]"
            placeholder="Telefon Numarası"
            value={phoneNumber}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPhoneNumber(e.target.value)
            }
          />
        </div>
        <div
          className="bg-[#D6FF00] text-[#000] rounded-full h-[55px] text-[16px] leading-[24px] flex w-full items-center justify-center mt-[30px]"
          onClick={handleSubmit}
        >
          {isLoading ? 'Yükleniyor...' : 'Beni Bul'}
        </div>
      </div>
    )
  }

  return (
    <div className="p-[20px]">
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="w-full bg-transparent border border-white p-[16px] text-white text-lg font-semibold focus:outline-none"
        ref={ref}
        hidden
      />
      <div className="text-[14px] mb-[10px]">
        Tarama işleminin başarılı olması için:
      </div>
      <div className="flex flex-col gap-[8px] text-[14px] mb-[10px]">
        <div className="flex gap-[10px]">
          <div className="w-[8px] h-[8px] bg-[#B2F142] rounded-full flex-shrink-0 mt-[8px]" />
          <div>Yüzünüzün net bir şekilde göründüğü bir br selfie yükleyin.</div>
        </div>
        <div className="flex gap-[10px]">
          <div className="w-[8px] h-[8px] bg-[#B2F142] rounded-full flex-shrink-0 mt-[8px]" />
          <div>Çok karanlık yada bulanık olmamasına dikkat edin</div>
        </div>
      </div>
      <div className="text-[14px] mb-[10px] text-[#71757E]">
        Çektiğiniz fotoğraf üçüncü taraflar ile <br />
        <b>paylaşılmayacaktır</b>.
      </div>
      <div
        className="bg-[#D6FF00] text-[#000] rounded-full h-[55px] text-[16px] leading-[24px] flex w-full items-center justify-center mt-[30px]"
        onClick={() => ref.current?.click()}
      >
        Selfie Çek
      </div>
    </div>
  )
}
